import { render, staticRenderFns } from "./VabSubmenu.vue?vue&type=template&id=0fe38f00"
import script from "./VabSubmenu.vue?vue&type=script&lang=js"
export * from "./VabSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fe38f00')) {
      api.createRecord('0fe38f00', component.options)
    } else {
      api.reload('0fe38f00', component.options)
    }
    module.hot.accept("./VabSubmenu.vue?vue&type=template&id=0fe38f00", function () {
      api.rerender('0fe38f00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabMenu/components/VabSubmenu.vue"
export default component.exports